import { render, staticRenderFns } from "./ExcSwitchBig.vue?vue&type=template&id=c0be77cc&scoped=true&"
import script from "./ExcSwitchBig.vue?vue&type=script&lang=ts&"
export * from "./ExcSwitchBig.vue?vue&type=script&lang=ts&"
import style0 from "./ExcSwitchBig.vue?vue&type=style&index=0&id=c0be77cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be77cc",
  null
  
)

export default component.exports